<script>
import { mapGetters, mapActions } from "vuex";

import Title from "@/components/_Shared/Title";
import Beginning from "./Steps/Beggining/Index";
import Address from "./Steps/Address/Index";
import Filters from "./Steps/Filters/Index";
import Pricing from "./Steps/Pricing/Index";
import ProfessionalOfferList from "./Steps/ProfessionalOfferList/Index";
import ProfessionalList from "./Steps/ProfessionalList/Index";
import Professional from "./Steps/Professional/Index";
import Schedule from "./Steps/Professional/Schedule";
import AdditionalInformation from "./Steps/AdditionalInformation/Index";
import Banner from "@/components/Banners/Banner";

export default {
  components: {
    Title,
    Beginning,
    Address,
    Filters,
    Pricing,
    ProfessionalOfferList,
    ProfessionalList,
    Schedule,
    Professional,
    AdditionalInformation,
    Banner
  },

  methods: {
    ...mapActions("orderScheduler", [
      "setOrderConfirmation",
      "unsetProfessional",
      "setScheduleConfirmation"
    ])
  },

  computed: {
    ...mapGetters("orderScheduler", [
      "canShowProfessionalFilter",
      "canShowPricingFilter",
      "canShowProfessionalOfferList",
      "canShowProfessionalList",
      "canShowSelectedProfessional",
      "canShowAdditionalInformation",
      "canShowProfessionalSchedule",
      "canShowConfirmedProfessional"
    ])
  },
  mounted() {
    try {
      posthog.capture("a_b_filter_a");
    } catch (e) {}
  }
};
</script>

<template>
  <div class="card scheduler">
    <!-- <Banner /> -->
    <Title title="Agende a sua próxima limpeza" />
    <Beginning v-if="!canShowProfessionalFilter" />

    <div class="content" v-else>
      <div class="left">
        <Address />

        <Filters v-if="canShowProfessionalFilter" />

        <Pricing v-if="canShowPricingFilter" />
      </div>

      <div class="right">
        <template>
          <ProfessionalOfferList v-if="canShowProfessionalOfferList" />
          <ProfessionalList v-else-if="canShowProfessionalList" />
        </template>

        <Schedule
          v-if="canShowProfessionalSchedule"
          @scheduleConfirmation="setScheduleConfirmation"
          @returnToSearch="(shouldUpdateAvailableProfessionals) => unsetProfessional(shouldUpdateAvailableProfessionals)"
        />

        <Professional v-if="canShowConfirmedProfessional" />

        <AdditionalInformation v-if="canShowAdditionalInformation" />

        <div v-if="canShowAdditionalInformation" class="actions">
          <button class="btn bg-purple" @click="setOrderConfirmation">
            <span>Confirmar agendamento</span>
          </button>

          <button class="btn bg-outlined" @click="unsetProfessional(true)">
            <span>Voltar para a pesquisa</span>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.scheduler {
  width: calc(100% - 32px);
  margin: 0 auto;
  user-select: none;
  display: flex;
  flex-direction: column;
}

.content {
  display: flex;
  flex-direction: column;
}

.left,
.right {
  left: 100%;
}

.card {
  margin: 0;
  padding: 16px;
}

.left > *:not(:first-child) {
  margin-top: 8px;
}

.right {
  margin-top: 16px;
}

.actions {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.bg-outlined {
  padding: 8px 16px;
}

@media (min-width: 768px) {
  .content {
    flex-direction: row;
    justify-content: space-around;
  }

  .left {
    width: 45%;
    margin-right: 16px;
  }

  .right {
    width: 55%;
    margin-top: 0;
    overflow-y: scroll;
    max-height: calc(100vh - 70px - 45px - 35px - 32px);
  }
}

@media (min-width: 1024px) {
  .right {
    max-height: calc(100vh - 120px - 45px - 75px - 32px);
    padding: 0 16px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/PurchaseFlow/Components/Scheduler/Index.vue